import { withPrefix } from 'gatsby';
import ButtonWithIcon from '@vfuk/core-button-with-icon';
import usingOpcoUrl from '@/helpers/prefixHelper';

interface BackButtonProps {
  step: number;
  disableSteps?: boolean;
  buttonLink: string;
  handleButtonClick: () => void;
}

const BackButton = ({ step, disableSteps = false, buttonLink, handleButtonClick }: BackButtonProps) => {
  const firstStep = disableSteps || step === 0;

  return (
    <ButtonWithIcon
      icon={{
        name: 'chevron-left',
        justify: 'left',
      }}
      inverse
      text={firstStep ? 'Cancel' : 'Back'}
      {...(firstStep && { href: usingOpcoUrl(withPrefix(`${buttonLink}`)) })}
      appearance="secondary"
      onClick={handleButtonClick}
    />
  );
};

export default BackButton;
